'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource', function($resource) {
    return $resource('api/phases/:phaseId', null, {
        getAll: {method: 'GET'},
        get: {method: 'GET'},
        create: {method: 'POST'},
        update: {method: 'PUT'},
        remove: {method: 'DELETE'},
        enable: {url: 'api/phases/:phaseId/enable', method: 'PUT'},
        delete: {url: 'api/phases/:phaseId/delete', method: 'PUT'},
        getDefault: {url: 'api/phases/default', method: 'GET'},
        setDefault: {url: 'api/phases/:phaseId/default', method: 'PUT'},
        isUniqueName: {url: 'api/phases/unique/name/:name', method: 'GET'},
        exists: {url: 'api/phases/exists', method: 'GET'},
    });
}];
